module.exports = __webpack_public_path__ + "img/shop.c50a95b9.png";